import { createSlice } from '@reduxjs/toolkit'
import initialState from './state'

export const counterSlice = createSlice({
  name: 'theme',
  // state数据的初始值
  initialState,
  // 定义的action。由于内置了immutable插件，可以直接使用赋值的方式进行数据的改变
  reducers: {
    setCollapsed: (state) => {
      state.collapsed = !state.collapsed
    },
    setColorPrimary: (state, action) => {
      state.theme = action.payload
    },
    setScreenValue: (state, action) => {
      const { width, height } = action.payload
      state.screenWidth = width
      state.screenHeight = height
    }
  },
})

export const { setCollapsed, setColorPrimary } = counterSlice.actions

export default counterSlice.reducer